/* eslint-disable */
var icon = require('vue-svgicon')
icon.register({
  'action/sabotage': {
    width: 32,
    height: 32,
    viewBox: '0 0 32 32',
    data: '<g _fill="#1D1D1B"><path pid="0" d="M16 32C7.178 32 0 24.822 0 16S7.178 0 16 0s16 7.178 16 16-7.178 16-16 16zm0-30C8.28 2 2 8.28 2 16s6.28 14 14 14 14-6.28 14-14S23.72 2 16 2z"/><path pid="1" d="M16 4C9.371 4 4 9.371 4 16s5.371 12 12 12 12-5.371 12-12S22.629 4 16 4zm6.207 9.5h-3L13.5 19.207v3l-2.146 2.146-.707-.707 1.854-1.854V19.5h-2.293l-1.854 1.854-.707-.707L9.793 18.5h3l5.707-5.707v-3l2.146-2.146.707.707-1.853 1.853V12.5h2.293l1.854-1.854.707.707-2.147 2.147z"/></g>'
  }
})
